import fetch from 'auth/GenericFetchInterceptorV5'

const ProdottiService = {}

ProdottiService.getProdottiLotsByCompany = function (companyDocId) {
    return fetch({
        url: `/api/catalogs?&populate=*&filters[company][documentId]=${companyDocId}&populate[catalog][product][warehouse_articles][populate][0]=storage`
    })
}

ProdottiService.getProdottiLotsByCompanyV2 = function (companyDocId) {
    return fetch({
        url: `/api/catalogs?filters[company][documentId]=${companyDocId}&populate[product][populate][supplier]=true&populate[product][populate][warehouse_articles][populate][0]=storage&populate[product][populate][warehouse_articles][populate][1]=lot`
    })
}

ProdottiService.getProdottiLotsByCompanyAfter = function (companyDocId, updatedAtISO) {
    return fetch({
        url: `/api/catalogs?populate=*&filters[company][documentId]=${companyDocId}&filters[product][updatedAt][$gt]=${updatedAtISO}`
    })
}

ProdottiService.getProdottiLotsByCompanyAfterV2 = function (companyDocId, updatedAtISO) {
    return fetch({
        url: `/api/catalogs?filters[company][documentId]=${companyDocId}&filters[product][updatedAt][$gt]=${updatedAtISO}&populate[product][populate][supplier]=true&populate[product][populate][warehouse_articles][populate][0]=storage&populate[product][populate][warehouse_articles][populate][1]=lot`
    })
}

// New method to get just the count of products for a company
ProdottiService.getProdottiLotsByCompanyCount = function (companyDocId) {
    return fetch({
        url: `/api/catalogs?filters[company][documentId]=${companyDocId}&pagination[pageSize]=1&pagination[page]=1`
    })
}

ProdottiService.getMagazziniQtabyProductId = function (companyId, productId) {
    return fetch({
        url: `/api/lots?filters[product][documentId][$eq]=upkz086ssze489268pgq9aby&filters[storage][company][documentId][$eq]=wegg4azb099kjoml0ye7kb10&populate[storage][populate][company]=true&populate[product]=true`
    })
}

ProdottiService.createFullProduct = function (data) {
    return fetch({
        url: `/api/products/create-full-product`,
        method: 'POST',
        data: data
    })
}
ProdottiService.modificaProduct = function (data, id) {
    return fetch({
        url: `/api/products/${id}?populate[supplier]=true&populate[warehouse_articles][populate]=storage`,
        method: "PUT",
        data: data
    });
}

ProdottiService.getDettaglioProduct = function (id, companyDocumentId) {
    return fetch({
        url: `/api/products/${encodeURIComponent(id)}/stock-details?${new URLSearchParams({companyDocumentId})}`,
        method: 'GET',
    })
}

export default ProdottiService;
